import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-thumb",
  "use": "icon-icon-thumb-usage",
  "viewBox": "0 0 13.3 13.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.3 13.5\" id=\"icon-icon-thumb\"><title>资源 121</title><g id=\"icon-icon-thumb_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-thumb_图层_1-2\" data-name=\"图层 1\"><path d=\"M0,6.3v6.1a1.1,1.1,0,0,0,1.1,1.1H2V5.3H1.1A1,1,0,0,0,0,6.3Z\" /><path d=\"M12,4.2H8.1a6.8,6.8,0,0,0,.3-1.9A2.3,2.3,0,0,0,6.2,0c-.9.2-1,1-1,2v.9A2.5,2.5,0,0,1,3,5.3H2.8v8.2h7.7a1.5,1.5,0,0,0,1.6-1.3l1.2-6.1A1.6,1.6,0,0,0,12,4.2Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-thumb.svg
// module id = MZtb
// module chunks = 72